import { BehaviorSubject } from "rxjs";

import { Component, Input } from "@angular/core";
import { IBaseChildViewManagement } from "./base-child-view.interface";
import { ViewData } from "./_page/viewdata.model";
import { LifetimeManagement } from "./base/lifetime-management";
import { Developer } from "./base/developer";
import { DeveloperModeHelper } from "./developer/developer-mode.helper";
// import { Developer } from "@app/pages/base/developer";
// import { ViewData } from "@app/pages/ui/viewdata.model";

@Component({template:''})
export class ChildViewManagement extends Developer implements IBaseChildViewManagement {

  constructor(protected _dev: DeveloperModeHelper) {
    super(_dev);
  }
  _items = new BehaviorSubject<ViewData>(null);
  
  @Input() set items(value: ViewData) {
    this._items.next(value);
  }

  get items() {
    return this._items.getValue();
  }

  get items$() {
    return this._items;
  }

  ngOnInit() : void {
    super.ngOnInit();
  }

  ngOnDestroy() : void {
    super.ngOnDestroy();
  }
}